import { CSSProperties, FunctionComponent } from 'react';
import './decoration.css'

type Props = {
    src: string;
    additionalStyles?: CSSProperties;
}

export const Decoration: FunctionComponent<Props> = ({src, additionalStyles={}}) => {

  
    return <>
    <div className="img-container" style={additionalStyles}>
        <img className="hover" src={src}/>
    </div>
   </>
  };
  